import { useGLTF } from '@react-three/drei';
import * as global from "../../data/global";

export function An0(props) {
    const { nodes } = useGLTF('3ds/an/An0.gltf');
    return (
        <group {...props} dispose={null}>
            <mesh
                ref={e => {
                    if (!e) return;
                    if (!global.gw.geometries.An0) {
                        global.gw.geometries.An0 = e.geometry;
                    }
                }}
                name="An0"
                geometry={nodes.An0.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/An0.gltf');
